import React, { Component } from 'react';

import { withStyles } from "@material-ui/core/styles";
import { connect } from 'react-redux';
import CrudForUserCantieri from './crud/Cantieri/CrudForUserCantieri'
import { modelProps } from '../../../model/Cantieri';


import { styles } from '../../css/commonstyles'




class Cantieri extends Component {

    constructor(props) {
        super(props);

    }



    render() {

        const { classes } = this.props;

        return (
            <div className={classes.backgroundStylefafafa} >
                <div className={classes.spacingStyle3} >
                    <CrudForUserCantieri
                        modelName="Cantieri"
                        modelNameSingolare="Cantieri"
                        modelProps={modelProps}
                    />
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {

    }

}

const mapDispatchToProps = (dispatch) => {

    return {


    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(Cantieri));